import { dir } from './directory'

const titleMap = {
  [`${dir()}/`]: "JD",
  [`${dir()}/home`]: "JD",
  [`${dir()}/login`]: "Login",
  [`${dir()}/forgot`]: "Forgot",
  [`${dir()}/password`]: "Password",
  [`${dir()}/dashboard`]: "Dashboard",
  [`${dir()}/biodata-diri`]: "Biodata Diri",
  [`${dir()}/detail-soal`]: "Detail Soal",
  [`${dir()}/ruang-tes-frt`]: "Ruang Tes FRT",
  [`${dir()}/ruang-tes-disc`]: "Ruang Tes DISC",
  [`${dir()}/ruang-tes-deskripsi`]: "Ruang Tes Deskripsi",
  [`${dir()}/ruang-tes-gambar`]: "Ruang Tes Gambar",
}

export const myTitles = (path) => {
  if (titleMap[path]) {
    return titleMap[path]
  }

  return "JD"
}
